// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * Renders a paper picker HTML select list
 */
M.View.ProductDetails.RadioFormatPicker = Backbone.View.extend({
  tagName: 'table',
  className: 'radioFormatPicker radioPicker',

  events: {
    'change': 'onChange'
  },

  initialize: function() {
    var that = this;
    this.$el = $(this.el);
    this.model.bind('priceUpdated', function() {
      that.render();
    });
  },

  /**
   * Renders the HTML for the radio format picker input.
   */
  render: function() {
    var that = this;
    var stampDenominations = this.options.stampDenominations
    var denomination;
    this.$el.empty();
    this.model.eachFormatPricePair(function (formatId, priceDiff) {

      // Only display formats in FORMAT_OPTIONS_FOR_PDP on the format picker
      // because not all formats available for a product are meant to be shown
      // on the PDP. For example, Folded (Blank Inside) is a valid format
      // option, but is not meant to be exposed to customers on the PDP.
      var formatOptions = M.Model.ProductDetails.FORMAT_OPTIONS_FOR_PDP;
      if (_.contains(formatOptions, formatId)) {

        // Special Case: In some cases, we don't want to show folded blank.
        if (formatId == M.FormatOptions.FOLDED_BLANK &&
            !that.shouldShowFoldedBlank()) {
          return;
        }

        var formatName = M.Model.ProductDetails.FORMAT_OPTION_LABELS[formatId];

        // Special Case: stamps
        if (stampDenominations) {
          denomination = Math.floor(stampDenominations[formatId] * 100);
          formatName = formatName + ' (' + denomination +'¢)'
        }

        var formatElem = that.createFormatOptionElem(formatId, formatName,
          priceDiff);
        that.$el.append(formatElem);
      }
    });

    // Truncate long paper option descriptions in order to keep
    // the "personalize" button above the fold.
    this.$el.find('.caption').jTruncate({
      length: 22, lessText: 'less'
    });

    // Bind to the 'more'/'less' link created by jTruncate.
    // Note: We are using the class of the link to find the element since
    // jTruncate does not return a reference to it. Binding to .caption does not
    // work because the link intercepts the click.
    var $toggleLink = this.$el.find('.truncate_more_link');
    $toggleLink.click(function(e) {
      var $el = $(e.target);
      var desc = $el.parents('.description').find('label').text();
      var linkText = $el.text() === 'more' ? 'less' : 'more';
      var sku = that.model.get('productSku');
      that.triggerDescToggleTracking(linkText, desc, sku);
      that.trigger('moreButtonClicked');
    });

    return this;
  },

  /**
   * Logs tracking event when the user toggles the description
   * with the more|less link.
   *
   * Unfortunately, we can't append track API events using the declarative style
   * due to the jTruncate jQuery plugin handling the description text toggling
   */
  triggerDescToggleTracking: function(linkText, formatDesc, sku) {
    try {
      M.sendTrackAPI({
        'feature': M.GA.TRACK_EVENT_CATEGORY.PDP,
        'event': M.GA.TRACK_EVENT_ACTION.PRODUCT_OPTION_DESCRIPTION_TOGGLE,
        'option_type': 'format',
        'option_value': encodeURIComponent(formatDesc),
        'sku': sku,
        'link_text': linkText
      });
    } catch (e) {
      console.log('Unable to log trackAPI event for format description toggle');
    }
  },

  /**
   * Returns true if the Folded Blank option should be shown.
   *
   * Currently, we hide Folded Blank if Folded Message is also an available
   * option.
   */
  shouldShowFoldedBlank: function() {
    return !_(this.model.get('formatOptionList')).
        contains(M.FormatOptions.FOLDED_TEXT);
  },

  /**
   * Returns true if Yearline is an available format option, even if it is not a
   * visible option.
   */
  hasYearline: function() {
    return _(this.model.get('formatOptionList')).
        contains(M.FormatOptions.YEARLINE);
  },

  getCaptionLabels: function() {
    // Special case: show different captions for placecards (PLC) and
    // table numbers (TBL), and for whether or not they have guest
    // name printing enabled.

    var sku = this.model.get('productSku');
    if (this.model.get('isPlacecard')) {
      return this.options.isPartyProductIndividualCustomization
        ? M.View.ProductDetails.FORMAT_CAPTIONS_PLACECARDS_GUEST_PRINTING
        : M.View.ProductDetails.FORMAT_CAPTIONS_PLACECARDS;
    } else if (M.SKU.isTableNumber(sku)) {
      return M.View.ProductDetails.FORMAT_CAPTIONS_TABLE_NUMBER_PRINTING;
    }
    return M.View.ProductDetails.FORMAT_CAPTIONS;
  },

  getCssClassnames: function() {
    // Special case: show different icons for placecards (PLC) and
    // table numbers (TBL)
    var sku = this.model.get('productSku');
    if (M.SKU.isTableNumber(sku) || this.model.get('isPlacecard')) {
      return M.View.ProductDetails.FORMAT_ICON_CSS_CLASSNAMES_PLACECARDS;
    }
    return M.View.ProductDetails.FORMAT_ICON_CSS_CLASSNAMES;
  },

  /**
   * Returns a <tr> element containing the input and label for the format
   * option.
   */
  createFormatOptionElem: function(value, formatName, formatPriceDiff) {
    var captionLabels = this.getCaptionLabels();
    var cssClassnames = this.getCssClassnames();

    var description = captionLabels[value];

    // Special Case: If folded text and folded yearline are both available, add
    // yearline to the description of folded text.
    if (value == M.FormatOptions.FOLDED_TEXT && this.hasYearline()) {
      description = 'Blank, photo, or Yearline&trade; inside';
    }

    var tr = $('<tr>');
    var radioCol = $('<td>').addClass('input');
    // Note: IE requires you to create input DOM elements in one line:
    // http://stackoverflow.com/questions/6432246/
    // radio-buttons-and-attrchecked-checked-does-not-work-in-ie7
    var radioFormatElem = $("<input />", {
      type: 'radio',
      id: 'format-' + value,
      checked: false,
      value: value
    });
    if (value == this.model.get('format')) {
      radioFormatElem.attr('checked', true);
    }
    radioCol.append(radioFormatElem);

    var descriptionCol = $('<td>').addClass('description');
    var labelEl = $('<label>');
    var wrapSpan = $('<span>');
    wrapSpan.attr('class', 'type');
    wrapSpan.text(formatName);
    labelEl.html(wrapSpan);
    if (value == this.model.get('format')) {
      labelEl.addClass('checked');
    }
    labelEl.attr('for', 'format-' + value);
    descriptionCol.append(labelEl);

    var captionHtml = description;
    if (captionHtml) {
      var captionEl = $('<span>');
      captionEl.addClass('caption');
      captionEl.css('cursor', 'pointer');
      captionEl.html(captionHtml);
      descriptionCol.append('&nbsp;&nbsp;');
      descriptionCol.append(captionEl);
    }

    var iconCol = $('<td>');
    iconCol.addClass('icon');
    var icon = $('<img>');
    icon.addClass('sprite');
    icon.addClass(cssClassnames[value]);
    icon.addClass('floatR');
    icon.attr('src', M.img_src("/static/images/sprite_placeholder.png"));
    iconCol.append(icon);

    var priceDeltaCol = this.getPriceDeltaCol(formatPriceDiff);

    tr.append(radioCol, descriptionCol, iconCol, priceDeltaCol);
    return tr;
  },

  getPriceDeltaCol: function(formatPriceDiff) {
    var priceDeltaCol = $('<td>').addClass('priceDelta');
    if (this.options.shouldShowPriceDiff){
      var priceDiffElem = $('<span>')
        .attr('class', 'priceDiff');
      if (formatPriceDiff % 1) {
        formatPriceDiff = formatPriceDiff.toFixed(2);
      }
      if (formatPriceDiff !== null) {
        priceDiffElem.html('+&nbsp;$' + formatPriceDiff);
      }
      priceDeltaCol.append(priceDiffElem);
    }
    return priceDeltaCol;
  },

  /**
   * Triggers a formatSelected event when the format is changed.
   */
  onChange: function(e) {
    var formatId = parseInt(e.target.value);
    this.trigger('formatSelected', formatId);
  }
});
